'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, type ButtonProps } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'

import { ProductSearchRefinementsDialog } from './ProductSearchRefinementsDialog'

type ProductSearchRefinementsButtonProps = Omit<ButtonProps, 'onClick'>

export const ProductSearchRefinementsButton: FC<
  ProductSearchRefinementsButtonProps
> = (props) => {
  const dialogControls = useOpenableControls()

  return (
    <>
      <Button
        color="primary"
        size="medium"
        variant="outlined"
        {...props}
        onClick={dialogControls.handleOpen}
      >
        <FormattedMessage id="general.label.filterSearch" />
      </Button>
      <ProductSearchRefinementsDialog
        onClose={dialogControls.handleClose}
        open={dialogControls.isOpen}
      />
    </>
  )
}
